import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

//Import
import JobsTabBlog from "../Jobick/Jobs/JobsTabBlog/JobsTabBlog";
import JobPreview from "../Jobick/Jobs/JobPreview";
import axios from "axios";
import { Button } from "react-bootstrap";
import { data } from "jquery";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setCourses,
  setJobCategory,
  fetchLocations,
} from "../../../store/actions/CourseAction";
import { truncate } from "../../../utils/helper";

const JobsByLocation = () => {
  const [search, setSearch] = useState("");
  const [control4, setControl4] = useState("Choose Course");
  const [control6, setControl6] = useState("Job Type");
  const [control5, setControl5] = useState("Passout Batch");
  const [control7, setControl7] = useState(0);
  const [control8, setControl8] = useState("");
  const [courseId, setCourseId] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedcourse, setCourse] = useState("");
  const [selectedtype, setType] = useState("");
  const [selectedbatch, setBatch] = useState("");
  const [selectedCategory, setCategory] = useState(0);
  const [selectedLocation, setLocation] = useState(0);
  const [cid, setCid] = useState("");
  const courses = useSelector((state) => state.courses.courses);
  const categories = useSelector((state) => state.job_category.job_category);
  const locations = useSelector((state) => state.locations.locations);
  const collegeId = useSelector((state) => state.college_id.college_id);
  const currentYear = new Date().getFullYear();
  const dispatch = useDispatch();
  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
    const storedCategory = localStorage.getItem("job_category");
    if (storedCategory) {
      dispatch(setJobCategory(JSON.parse(storedCategory)));
    }

    dispatch(fetchLocations(collegeId));
  }, [dispatch, collegeId]);

  useEffect(() => {
    // console.log(control4, courseId);
    setCourse(control4);
    setType(control6);
    setBatch(control5);
    setCid(courseId);
    setCategory(control7);
    setLocation(control8);
  }, [control4, control6, control5, control7, control8, courseId]);
  const handleSearch = () => {
    setSearch(inputValue);
    setCourse(control4);
    setType(control6);
    setBatch(control5);
    setCid(courseId);
    setLocation(control8);
  };

  const resetFilter = () => {
    setControl4("Choose Course");
    setControl6("Job Type");
    // setControl5("Passout Batch"); // Commented out since we removed this dropdown
    setCourseId(null);
    setSearch("");
    setCourse("Choose Course");
    setType("Job Type");
    setBatch("Passout Batch");
    setCid(null);
    setInputValue("");
    setCategory(0);
    setControl7(0);
    setControl8("");
    setLocation("");
  };

  return (
    <>
      <div className="d-flex align-items-center flex-wrap search-job bg-white px-0 mb-4">
        <div className="col-xl-3 col-xxl-3 col-lg-3 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {control4 ? truncate(control4, 20) : "Choose Course"}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className="text-primary"
                onClick={() => {
                  setControl4("Choose Course");
                  setCourseId(null);
                }}
              >
                Choose Course
              </Dropdown.Item>
              {courses?.map((course) => (
                <Dropdown.Item
                  key={course.filter_id}
                  className="text-primary"
                  onClick={() => {
                    setControl4(course.name);
                    setCourseId(course.filter_id);
                  }}
                >
                  {course.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* <div className="col-xl-2 col-xxl-2 col-lg-2 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0  style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {control6}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl6("Job Type")}
              >
                Job Type
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl6("Campus Invite")}
              >
                Campus Invite
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl6("Internship")}
              >
                Internship
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div> */}

        {/* <div className="col-xl-2 col-xxl-2 col-lg-2 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0  style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {control5}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl5("Passout Batch")}
              >
                Passout Batch
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl5(currentYear - 1)}
              >
                {currentYear - 1}
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl5(currentYear)}
              >
                {currentYear}
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl5(currentYear + 1)}
              >
                {currentYear + 1}
              </Dropdown.Item>
              <Dropdown.Item
                className=" text-primary"
                onClick={() => setControl5(currentYear + 2)}
              >
                {currentYear + 2}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div> */}

        <div className="col-xl-3 col-xxl-3 col-lg-3 col-sm-4 col-12 search-dropdown d-flex align-items-center mb-2 mb-sm-0">
          <Dropdown className="form-control border-0 style-1 h-auto w-100">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {(() => {
                if (control7 === 0) {
                  return "All Categories";
                }
                const category = categories?.find(
                  (cat) => cat.filter_id === control7,
                );
                return truncate(
                  category?.category_name ?? "All Categories",
                  25,
                );
              })()}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1 w-100">
              <Dropdown.Item
                className="text-primary"
                onClick={() => setControl7(0)}
              >
                All Categories
              </Dropdown.Item>
              {categories &&
                categories.length > 0 &&
                categories.map((category) => (
                  <Dropdown.Item
                    key={category.filter_id}
                    className="text-primary"
                    onClick={() => setControl7(category.filter_id)}
                  >
                    {category.category_name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="col-xl-5 col-xxl-5 col-lg-5 col-sm-5 col-12 d-flex job-title-search pe-0  mt-2 mt-sm-0">
          <div className="input-group search-area w-100">
            <input
              type="text"
              value={inputValue}
              className="form-control h-auto"
              placeholder="Search by Job Location..."
              onChange={(e) => setInputValue(e.target.value)}
            />
            <span className="input-group-text">
              <Button onClick={handleSearch} className="btn btn-primary btn-sm">
                <span className="d-none d-sm-inline-block">Search</span>
                <i className="flaticon-381-search-2 ms-1" style={{ fontSize: '14px', verticalAlign: 'middle' }}></i>
              </Button>
            </span>
          </div>
        </div>
        <div className="col-xl-1 col-xxl-1 col-lg-1 col-12 d-flex align-items-center justify-content-lg-end justify-content-center">
          <button
            onClick={() => {
              resetFilter();
            }}
            className="btn btn-danger btn-sm"
          >
            Reset
          </button>
        </div>
      </div>

      {/* Location buttons section */}
      <div className="mb-4">
        <div
          className="d-flex align-items-center"
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            width: "fit-content",
          }}
        >
          <div className="btn-group" role="group" style={{ gap: 3 }}>
            <button
              className="btn btn-md"
              style={
                control8 === ""
                  ? {
                      backgroundColor: "#ffa755",
                      borderRadius: "10px",
                      color: "white",
                      fontWeight: "bold",
                    }
                  : { backgroundColor: "white", borderRadius: "10px" }
              }
              onClick={() => setControl8("")}
            >
              All
            </button>
            {locations &&
              locations.length > 0 &&
              locations.map((location) => (
                <button
                  key={location.city}
                  className="btn btn-md"
                  style={
                    control8 === location.city
                      ? {
                          backgroundColor: "#ffa755",
                          borderRadius: "10px",
                          color: "white",
                          fontWeight: "bold",
                        }
                      : { backgroundColor: "white", borderRadius: "10px" }
                  }
                  onClick={() => setControl8(location.city)}
                >
                  {location.city}
                </button>
              ))}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {selectedcourse != "" &&
            selectedbatch != "" &&
            selectedtype != "" && (
              <JobsTabBlog
                course={selectedcourse}
                courseId={cid}
                batch={selectedbatch}
                type={selectedtype}
                search={search}
                category={selectedCategory}
                location={selectedLocation}
                url={"/api/freshment_portal_apis/JobsHome/get_jobs_by_location"}
              />
            )}
        </div>
      </div>
    </>
  );
};
export default JobsByLocation;
